module.exports = __webpack_public_path__ + "static/logo-0de86a4b927e4d8664aa8ae193d1ad45.svg";